import { render, staticRenderFns } from "./tugas-fungsi.vue?vue&type=template&id=b32d9d5e&"
import script from "./tugas-fungsi.vue?vue&type=script&lang=js&"
export * from "./tugas-fungsi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports